import {Component} from '@angular/core';
import {PlanModelService} from '../../common/service/plan-model.service';
import {PermissionsService} from '../../common/service/permissions.service';
import {ControlContainer, FormsModule, NgForm} from '@angular/forms';
import {PDF_CREATION_METHOD} from '../../common/constants';
import {NgClass} from '@angular/common';
import {NlrFormFieldHasErrorPipe} from '../../common/pipe/nlr-form-field-has-error.pipe';

@Component({
    selector: 'agreement-and-consent',
    imports: [FormsModule, NgClass, NlrFormFieldHasErrorPipe],
    templateUrl: './agreement-and-consent.component.html',
    styleUrl: './agreement-and-consent.component.scss',
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class AgreementAndConsentComponent {
    title = 'Agreement and consent';

    permissions = ['EDIT_LODGE', 'VIEW_LODGE'];

    constructor(
        private planModelService: PlanModelService,
        private permissionsService: PermissionsService
    ) {}

    getModel() {
        return this.planModelService.getModel();
    }

    isDigitalOrPortalPlan() {
        return (
            this.getModel().pdfCreationMethod === PDF_CREATION_METHOD.DIGITAL_PLAN ||
            this.getModel().pdfCreationMethod === PDF_CREATION_METHOD.SURVEYOR_PORTAL
        );
    }

    isDisabled() {
        return this.planModelService.readonly || !this.permissionsService.hasEditPermission(this.permissions);
    }
}
